import React from 'react';

import { Product } from '../../hooks/useProducts';
import { formatPrice } from '../../utils/Formatting';
import './ProductCard.css';
import { useSettingsRedux } from '../../hooks/useSettingsRedux';
import LazyImage from '../LazyImage';

interface ProductCardProps {
  product: Product;
  isSelected: boolean;
  onClick: (product: Product) => void;
  allPrizesCollected: boolean;
}

const ProductCard: React.FC<ProductCardProps> = ({ product, isSelected, onClick, allPrizesCollected }) => {
  const { settings } = useSettingsRedux();
  const pickProductLabel = settings?.translations?.feed?.pickProduct ?? 'Select';

  return (
    <div
      className={`playmerce-card playmerce-product-card ${isSelected ? 'selected' : ''}`}
      onClick={() => onClick(product)}
    >
      <div className="card-content">
        <div className="product-stack">
          <div className="product-image-container">
            {product.featuredImage ? (
              <LazyImage
                src={product.featuredImage.url}
                alt={product.featuredImage.altText || product.title}
                className="product-image"
              />
            ) : (
              <div className="no-image-placeholder">
                <p>No image</p>
              </div>
            )}
          </div>
          <div className="product-info">
            <h3 className="product-title">{product.title}</h3>
            <div className="price-action-row">
              <p className="product-price">
                {formatPrice(
                  product.priceRange.minVariantPrice.amount,
                  product.priceRange.minVariantPrice.currencyCode
                )}
              </p>
              <button
                className={`product-choose-button ${!allPrizesCollected ? 'button-hidden-via-opacity' : ''}`}
                disabled={!allPrizesCollected}
              >
                {pickProductLabel}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
